import React from "react";
import { observer } from "mobx-react-lite";
import { searchStore } from "features/ProductSearch/SearchStore";
import ProductsListContainer from "../ProductsListContainer";
import ProductRowsList, { RowsListProps } from "../ProductRowsList";
import EmptyState from "../EmptyState";
import { InternalProductSearchOutput } from "api-client";
import { IconCopy, IconEdit, IconInfoCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import useFeatureFlag from "hooks/useFeatureFlag";
import useComponentActions from "./useComponentActions";
import ProductDetailsModal from "features/ProductDetailsModal";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";

const DefaultComponents = (props: RowsListProps) => {
  const { t } = useTranslation();
  const { isFeatureVisible } = useFeatureFlag();
  const { duplicateComponent, editComponent } = useComponentActions();

  function shouldShowEmptyView() {
    return (
      !searchStore.productSearchLoading &&
      searchStore.searchResults.items.length === 0
    );
  }

  const settingsItems = (
    product: InternalProductSearchOutput | null | undefined
  ) => {
    const itemList = [
      {
        name: t("mapping.duplicateComponent"),
        icon: <IconCopy width={18} className="mr-2" />,
        onClick: () => duplicateComponent(product?.id),
        className: "text-gray-700",
        disabled: COEStore.openedSearchInCE,
      },
      {
        name: t("mapping.showDetails"),
        icon: <IconInfoCircle width={18} className="mr-2" />,
        onClick: () =>
          searchStore.setOpenDetails({ open: true, product: product }),
        className: "text-gray-700",
        disabled: false,
      },
    ];

    if (isFeatureVisible("edit_default_components")) {
      itemList.push({
        name: t("mapping.editComponent"),
        icon: <IconEdit width={18} className="mr-2 min-w-[15px]" />,
        onClick: () => editComponent(product?.id),
        className: "text-gray-700",
        disabled: COEStore.openedSearchInCE,
      });
    }
    return itemList;
  };

  return (
    <>
      <ProductsListContainer>
        {shouldShowEmptyView() ? (
          <EmptyState />
        ) : (
          <ProductRowsList match={props.match} settingsItems={settingsItems} />
        )}
      </ProductsListContainer>
      <ProductDetailsModal
        productId={searchStore.openDetails.product?.id}
        productName={searchStore.openDetails.product?.name}
        productType={searchStore.openDetails.product?.type}
        open={searchStore.openDetails.open}
        close={() =>
          searchStore.setOpenDetails({ open: false, product: undefined })
        }
      />
    </>
  );
};

export default observer(DefaultComponents);
